import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.MobileInfoModule', {
    description: `
        There's an ApprovalMax mobile app that allows browsing through approval request,
        chat with requester and approvers and make decisions.{br}{br}
        Would you like to try it?`,
});
